import React from 'react'
import R from 'ramda'
import {FormattedMessage} from 'react-intl'

import PriceField from './PriceField'
import AreaField from './AreaField'
import EstateTypeField from './EstateTypeField'
import RoomField from './RoomField'
import BathroomField from './BathroomField'
import { ButtonGroup, Button } from 'react-bootstrap'
import range from '../utils/range'

const Features = ({currency, areaUnit, options, query, onChange}) => {
  const rooms = R.path(['options', 'rooms'], query)
  const bathrooms = R.path(['options', 'bathrooms'], query)

  const {rental, prices, areas, types, estateTypes} = query.features

  const priceProps = {rental, currency, prices, onChange: onChange(['features','prices'])}
  const areaProps = {areaUnit, options, areas, onChange: onChange(['features', 'areas'])}
  const estateTypeFieldProps = {estateTypes, options, onChange: onChange(['features', 'estateTypes'])}
  const roomFieldProps = {value: rooms, onChange: onChange(['options', 'rooms'])}
  const bathroomFieldProps = {value: bathrooms, onChange: onChange(['options', 'bathrooms'])}

  const onButtonGroupClick = onChange(['features','rental']);

  const onRentalStyle = rental ? 'primary' : 'default';
  const onRentalClick = function () {
    onButtonGroupClick(true)
  }

  const onBuyingStyle = rental ? 'default' : 'primary';
  const onBuyingClick = function () {
    onButtonGroupClick(false)
  }

  const steps = rental ? [0,50, 500, 1000, 2000, 7000,] : [0,25000, 300000,500000,1000000,10000000,]
  const jumps = rental ? [50, 50, 50,100, 1000,] : [25000, 25000,50000,100000, 1000000,]

  const defaultValidValues = range(steps, jumps)
  Object.assign(priceProps, { validValues: defaultValidValues })

  return <div className="features-container">
      <div className="features-row-container">
        <ButtonGroup bsClass="rental-button-group">
          <Button onClick={onBuyingClick} bsStyle={onBuyingStyle}><FormattedMessage id="Buying" defaultMessage="Buying"/></Button>
          <Button onClick={onRentalClick} bsStyle={onRentalStyle}><FormattedMessage id="Renting" defaultMessage="Renting"/></Button>
        </ButtonGroup>
      </div>
      <div className="features-row-container">
        <div style={{flexBasis: '40%'}}>
          <PriceField {...priceProps}/>
        </div>
        <div style={{flexBasis: '40%'}}>
          <AreaField {...areaProps}/>
        </div>
      </div>
      <div className="features-row-container" style={{marginTop:'10px'}}>
        <div style={{flexBasis: '100%'}}>
          <EstateTypeField {...estateTypeFieldProps}/>
        </div>
      </div>
      <div className="features-row-container">
        <div style={{flexBasis: '45%'}}>
          <RoomField {...roomFieldProps}/>
        </div>
        <div style={{flexBasis: '45%'}}>
          <BathroomField {...bathroomFieldProps}/>
        </div>
      </div>
    </div>
}

Features.propTypes = {
  options: React.PropTypes.object.isRequired,
  currency: React.PropTypes.string.isRequired,
  areaUnit: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
  query: React.PropTypes.shape({
    features: React.PropTypes.shape({
      prices: React.PropTypes.object,
      areas: React.PropTypes.object,
      estateTypes: React.PropTypes.array,
    }).isRequired,
    options: React.PropTypes.shape({
      rooms: React.PropTypes.number,
    }).isRequired,
  }).isRequired

}

export default Features



/** WEBPACK FOOTER **
 ** ./app/components/Features.jsx
 **/